export const SET_APP_USERINFO = "SET_APP_USERINFO";
export const SET_TOTAL_SUBJECTS = "SET_TOTAL_SUBJECTS";
export const SET_ANNOUNCEMENTS = "SET_ANNOUNCEMENTS";
export const SET_ANNOUNCEMENTS_UNREAD = "SET_ANNOUNCEMENTS_UNREAD";
export const SET_MESSAGES_UNREAD = "SET_MESSAGES_UNREAD";
